export const GET_MAKE_UP_PUNCH_RULE_SETTING_CALL = 'GET_MAKE_UP_PUNCH_RULE_SETTING_CALL';
export const GET_MAKE_UP_PUNCH_RULE_SETTING_DONE = 'GET_MAKE_UP_PUNCH_RULE_SETTING_DONE';
export const GET_MAKE_UP_PUNCH_RULE_SETTING_FAIL = 'GET_MAKE_UP_PUNCH_RULE_SETTING_FAIL';
